module.exports = __webpack_public_path__ + "static/media/loading_unselected.b4417e8b.svg";